import { memo, useState, useLayoutEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';

// @ts-expect-error file does not have TS declarations
import sprocketUrl from 'bender-url!../images/sprocket.svg';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const GRID_BREAKPOINT_SMALL = '544px';
const randomNum = (min, max) => {
  return min + Math.floor(Math.random() * (max - min + 1));
};
const rain = keyframes(["from{opacity:0;}25%{opacity:1;}to{bottom:0;}"]);
const rotateClockwise = keyframes(["from{transform:rotate(0);}to{transform:rotate(1turn);}"]);
const rotateAnticlockwise = keyframes(["from{transform:rotate(0);}to{transform:rotate(-1turn);}"]);
const confettiStyle = css(["animation:", " ease-out forwards;background:", ";border-radius:2px;bottom:100%;height:16px;opacity:0;position:absolute;width:5px;z-index:3;&:nth-child(odd){background:", ";}&:nth-child(even){z-index:1;}&:nth-child(3n){animation-duration:", "ms;height:25px;width:7px;}&:nth-child(4n){animation-duration:", "ms;border-radius:50%;height:10px;width:10px;}&:nth-child(4n-7){background:", ";}&:nth-child(8n){height:30px;width:4px;}", ""], rain, ({
  withSprockets,
  theme
}) => withSprockets ? theme.color['fill-accent-red-default'] : theme.color['fill-brand-default'], ({
  theme
}) => theme.color['fill-accent-blue-default'], props => props.duration * 2, props => props.duration * 1.8, ({
  theme
}) => theme.color['fill-accent-red-default'], ({
  withSprockets
}) => withSprockets ? css(["&:nth-child(9n-2){animation:", " ease-out forwards,", " ease-out forwards;background:center / contain no-repeat url(", ");height:32px;width:32px;}&:nth-child(9n-4){animation:", " ease-out forwards,", " ease-out forwards;background:center / contain no-repeat url(", ");height:32px;width:32px;}"], rotateClockwise, rain, sprocketUrl, rotateAnticlockwise, rain, sprocketUrl) : '');
const getConfettiPieceStyle = duration => {
  const randomDuration = randomNum(duration * 0.6, duration * 1.3);
  const randomDelay = randomNum(0, duration * 0.75);
  return {
    animationDelay: `${randomDelay}ms`,
    animationDuration: `${randomDuration}ms`,
    left: `${randomNum(0, 100)}%`,
    transform: `rotate(${randomNum(-80, 80)}deg)`
  };
};
const Confetti = ({
  className,
  duration,
  pieces
}) => {
  const [confettiPieces, setConfettiPieces] = useState([]);
  useLayoutEffect(() => {
    if (!Array.isArray(confettiPieces)) {
      return () => {};
    }
    if (confettiPieces.length >= pieces) {
      const timeoutId = setTimeout(() => setConfettiPieces(null), duration * 2);
      return () => clearTimeout(timeoutId);
    }
    const newConfettiPieces = [...confettiPieces];
    for (let index = 0; index < 10; index += 1) {
      newConfettiPieces.push(
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx("div", {
        "data-test-id": "confetti-piece",
        className: className,
        style: getConfettiPieceStyle(duration)
      }, confettiPieces.length + index));
    }
    const requestId = requestAnimationFrame(() => setConfettiPieces(newConfettiPieces));
    return () => cancelAnimationFrame(requestId);
  }, [className, duration, pieces, confettiPieces, setConfettiPieces]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: confettiPieces
  });
};
const ConfettiContainer = styled.div.withConfig({
  displayName: "Confetti__ConfettiContainer",
  componentId: "y9dbas-0"
})(["@media only screen and (min-width:", "){height:", "%;left:", "%;overflow:hidden;pointer-events:none;position:absolute;top:-60px;width:", "%;", "}"], GRID_BREAKPOINT_SMALL, ({
  heightPercentage
}) => heightPercentage, ({
  widthPercentage
}) => (100 - widthPercentage) / 2, ({
  widthPercentage
}) => widthPercentage, ({
  fixedPosition,
  zIndex
}) => {
  if (fixedPosition) {
    return `
         position: fixed;
         left: 0;
         top: 0;
         width: 100vw;
         height: 100vh;
         overflow: hidden;
         z-index: ${zIndex !== undefined ? zIndex : 100};
        `;
  } else if (zIndex !== undefined) {
    return `z-index: ${zIndex};`;
  }
  return null;
});
const StyledConfetti = /*#__PURE__*/memo(styled(Confetti).withConfig({
  displayName: "Confetti__StyledConfetti",
  componentId: "y9dbas-1"
})(["", ""], confettiStyle));
const WrappedConfetti = ({
  fixedPosition = false,
  heightPercentage = 200,
  widthPercentage = 200,
  withSprockets = false,
  duration = 3000,
  pieces = 60,
  zIndex
}) => {
  const theme = useTheme();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ConfettiContainer, {
      "data-test-id": "confetti-container",
      fixedPosition: fixedPosition,
      heightPercentage: heightPercentage,
      widthPercentage: widthPercentage,
      zIndex: zIndex,
      children: /*#__PURE__*/_jsx(StyledConfetti, {
        duration: duration,
        pieces: pieces,
        withSprockets: withSprockets,
        theme: theme
      })
    })
  );
};
export default WrappedConfetti;